import React from 'react';
import {
  heroData,
  problemSolutionData,
  servicesData,
  trustPointsData,
  proofData,
  audienceData,
  processData,
  formData,
  footerData
} from '../data/mock';
import HeroSection from '../components/landing/HeroSection';
import ProblemSolutionSection from '../components/landing/ProblemSolutionSection';
import ServicesSection from '../components/landing/ServicesSection';
import TrustPointsSection from '../components/landing/TrustPointsSection';
import ProofSection from '../components/landing/ProofSection';
import AudienceSection from '../components/landing/AudienceSection';
import ProcessSection from '../components/landing/ProcessSection';
import FormSection from '../components/landing/FormSection';
import Footer from '../components/landing/Footer';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/2b1a8yim_Screenshot_20260123_012606_Drive.jpg";

const LandingPage = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('lead-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Logo Header */}
      <header className="w-full py-4 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <img 
            src={LOGO_URL} 
            alt="Just Cleaned" 
            className="h-12 md:h-14 w-auto object-contain"
          />
        </div>
      </header>

      <HeroSection data={heroData} onCtaClick={scrollToForm} />
      <ProblemSolutionSection data={problemSolutionData} onCtaClick={scrollToForm} />
      <ServicesSection data={servicesData} />
      <TrustPointsSection data={trustPointsData} />
      <ProofSection data={proofData} onCtaClick={scrollToForm} />
      <AudienceSection data={audienceData} />
      <ProcessSection data={processData} />
      <FormSection data={formData} />
      <Footer data={footerData} />
    </div>
  );
};

export default LandingPage;
